import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentCentre16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextAlignmentCentre16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.5 4a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1zm-1 3a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1zm.5 5.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h8.5a.5.5 0 0 1 .5.5m.5-2.5a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentCentre16);
